import { FC } from 'react';
import { ImSpinner8 } from 'react-icons/im';
import styled, { keyframes, Keyframes } from 'styled-components';
import { HStack } from '@bpba/ui-components';
import { MarginProps, WidthProps } from 'styled-system';

const ARIA_LABEL = 'Procesando. Aguarde por favor.';

export const Spinner: FC<WidthProps & MarginProps> = (props) => {
  return (
    <HStack justifyContent="center" margin={'24px auto'} aria-label={ARIA_LABEL} tabIndex={0} color="primary.0" {...props}>
      <SpinnerIcon />
    </HStack>
  );
};

const spinnerAnimation: Keyframes = keyframes`
    0% { transform: rotate(0deg);}
    100% { transform: rotate(359deg);}
`;

const SpinnerIcon = styled(ImSpinner8)`
  height: 100%;
  width: 100%;
  animation: ${spinnerAnimation} 2s infinite linear;
`;
